module.exports = __webpack_public_path__ + "static/horizontal-step-2-ab8f0c7ad8fae13d7d556dd5b6810f0c.png";